'use strict';

function ErrorCtrl($scope, $rootScope, errorObj, config) {
  $rootScope.loading = false;
  $scope.error = errorObj;
  setTimeout(function() {
    console.log('here');
    window.location = config.appBase;
  }, 5000);
}

ErrorCtrl.resolve = {
  errorObj: function() {
    return this.self.error;
  }
};
module.exports = ErrorCtrl;

angular.module('dokiv')
  .controller('ErrorCtrl', ['$scope', '$rootScope', 'errorObj', 'config', ErrorCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ErrorCtrl.js
// module id = 241
// module chunks = 0